import type { Money } from "@/api/types";

/** Whole paisa, so a limit is compared exactly. */
export const paisa = (value: string) => Math.round(Number(value || "0") * 100);

/** A limit nearly used is a warning, and one passed is a problem. */
export function limitTone(percent: number): "default" | "warn" | "bad" {
  if (percent >= 100) return "bad";
  return percent >= 80 ? "warn" : "default";
}

/** How much of a limit is used, in whole percent. A limit of zero is used by anything at all. */
export function limitUsed(outstanding: Money, limit: Money): number {
  const owed = paisa(outstanding);
  const allowed = paisa(limit);
  if (allowed === 0) return owed > 0 ? 100 : 0;
  return Math.round((owed / allowed) * 100);
}

/** True when this invoice would take what is owed past the limit. An empty limit is no limit. */
export function passesLimit(outstanding: Money, invoiceTotal: Money, limit: string): boolean {
  if (limit.trim() === "") return false;
  return paisa(outstanding) + paisa(invoiceTotal) > paisa(limit);
}

/** "Due in 5d", "Due today", or "12d overdue", from the due date, or the issue date without one. */
export function ageText(asAt: string, issued: string, due: string): string {
  const days = (Date.parse(asAt) - Date.parse(due || issued)) / 86_400_000;
  if (days > 0) return `${days}d overdue`;
  return days === 0 ? "Due today" : `Due in ${-days}d`;
}
